export default {
  specsvalue: 'Value',
  specsvalues: 'Values',
  verbose_specsvalue: 'a value',
  increment: 'Increment',
  short_title: 'Short title',
  use_exceptions: 'Use exceptions',
};
